import React from "react"
import PropTypes from "prop-types"
import MessageBox from "@/components/MessageBox"
import { withApi } from "@tencent/react-aio"
import * as ActionTypes from "@/stores/sale/actions"
import _ from "lodash"
import Dialog from "@/components/Dialog"
import { FormGroup } from "@tencent/spaui"
import CustomerIdInput from "@/business-components/sale/CustomerIdInput"

class SubmittedOnlineModal extends React.Component {
  static propTypes = {
    order: PropTypes.object.isRequired,
    version: PropTypes.number.isRequired,
    onSubmit: PropTypes.func,
  }

  state = {}

  render() {
    const { order } = this.props
    const { error } = this.state
    let customerId = order.lead.customerId
    let mpUserName = order.lead.customerMpUserName
    let companyName = order.lead.company.companyName
    let isUserInfoReady = !(_.isNil(customerId) && _.isNil(mpUserName))
    const customerReadOnly = this.props.customerReadOnly !== undefined ? this.props.customerReadOnly : false

    const customerIdIsRequired = this.props.customerIdIsRequired !== undefined ? this.props.customerIdIsRequired : false
    const { customer, customerStatus, customerError, customerMpUN, customerUnibdAI, uid, customerMpUserName, customerUnibdAppId } = this.state

    const customerHelpBlock = customerStatus === "error" ? customerError : customerStatus === "success" ? customer.customerName : ""

    return (
      <Dialog className="SubmittedOnlineModal" title="提交上线" subTitle={companyName} style={{ width: 640 }} {...this.props} onSubmit={this.onSubmit}>
        {customerId && (
          <React.Fragment>
            <p>
              <label>客户 ID：</label>
              {customerId}
            </p>
          </React.Fragment>
        )}
        {mpUserName && (
          <React.Fragment>
            <p>
              <label>客户名称：</label>
              {mpUserName}
            </p>
          </React.Fragment>
        )}
        {!(customerId || mpUserName) && (
          <FormGroup status={customerStatus} helpBlock={customerHelpBlock} className={customerIdIsRequired ? "required" : null} style={{ width: 200 }}>
            <blockquote className="info">请补充账户 ID 信息！</blockquote>
            <label htmlFor="customerId">账户 ID：</label>
            <CustomerIdInput customerReadOnly={customerReadOnly} key={customerMpUserName || customerId} acceptAccountId acceptMpUserName value={customerUnibdAppId || customerMpUserName || customerId} onChange={this.handleChangeCustomerId} />
          </FormGroup>
        )}

        {error && (
          <p className={"has-error"}>
            <span className={"error-message"}>发生错误：{error.message || "服务器错误"}</span>
          </p>
        )}
      </Dialog>
    )
  }

  handleChangeCustomerId = (e, value) => {
    const customerIdIsRequired = this.props.customerIdIsRequired !== undefined ? this.props.customerIdIsRequired : false
    if (customerIdIsRequired && value.value === "") {
      this.setState({
        customer: value.customer,
        customerStatus: "error",
        customerError: "必须填",
        error: "必须填",
      })
    } else {
      this.setState({
        customer: value.customer,
        customerStatus: value.status,
        customerError: value.error,
        error: value.error ? { message: value.error } : undefined,
      })
      if (value.customer) {
        this.setState({ uid: value.customer.customerId })
        if (value.customer.mp) {
          this.setState({ customerMpUN: value.customer.mp.mpUserName })
        }
        if (value.customer.unibd) {
          this.setState({ customerUnibdAI: value.customer.unibd })
        }
      } else {
        this.props.setStateValue("customerId", null)
        this.props.setStateValue("customerMpUserName", null)
        this.props.setStateValue("customerUnibdAppId", null)
      }
      this.props.setStateValue("customerStatus", value.status)
      this.props.setStateValue("customerError", value.error)
    }
  }

  onSubmit = () => {
    const { order, webApi } = this.props

    const params = {
      customerId: this.state.uid ? this.state.uid : null,
      customerMpUserName: this.state.customerMpUN ? this.state.customerMpUN : null,
      customerUnibdAppId: this.state.customerUnibdAI ? this.state.customerUnibdAI : null,
      orderId: order.orderId,
      leadId: order.leadId,
      version: this.props.version,
    }

    webApi
      .submitOrderOnline()
      .dispatchJson(ActionTypes.SUBMIT_ORDER_ONLINE, {
        data: params,
      })
      .then(
        (resp) => {
          this.context.success("订单提交上线成功")
          this.props.onSubmit()
          this.props.refreshTable()
        },
        (error) => {
          this.context.error("订单提交上线失败", error.message)
          this.props.onSubmit()
        }
      )
  }
}

export default withApi(SubmittedOnlineModal)

SubmittedOnlineModal.contextType = MessageBox
